








































































import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
//  @components
//  @types
import { UserProfile } from "@/types/userProfile";
import { CellData } from "@/types/VDataTable";
//  @modules
import { getModule } from "vuex-module-decorators";

@Component({
  components: {},
})
export default class DataCell extends Vue {
  @Prop({ type: Object }) data!: CellData;
  @Prop({ type: Array, default: () => [], required: true }) users!: any[];

  // @Data
  companySearch: string = "";
  internalSelected: UserProfile | null = null;

  //  @Getters
  get isActionsDataCell(): boolean {
    return this.data.type === "actions";
  }

  //  @Methods
  // map action name to icon and emitted event name (handler)
  getActionConfig(action: string): { icon: string; eventName: string } {
    switch ((action || "").toLowerCase()) {
      case "edit":
        return { icon: "$Edit", eventName: "EditEvent" };
      case "apikey":
        return { icon: "$Key", eventName: "APIKeyEvent" };
      case "delete":
        return { icon: "$Delete", eventName: "DeleteEvent" };
      default:
        return { icon: "$Edit", eventName: "EditEvent" };
    }
  }

  handleAction(action: string, payload: any = undefined): void {
    const cfg = this.getActionConfig(action);
    payload = this.data.userId ? this.data.userId : payload;
    this.$emit(cfg.eventName, payload);
  }
}
